import { SibBaseObject } from "../BaseObject/SibBaseObject";

export class ContractType extends SibBaseObject {
    name: string;
    code: string;
    description: string;
}
